import React from 'react'
import Chart from "react-apexcharts";
import { useOutletContext } from 'react-router-dom';
import ExceptionVariables from '../JSON Files/ExceptionVariables';
import { alignSingleBarLeft, hideBarPadLabel, niceAxisMax, formatAxisTick, CHART_PALETTE, CHART_TITLE_STYLE } from '../HelperFunction/helperFunction';

function SingleBarChart3({ fulldataset, type, isValue, range, maxValuedynamicVolume, axisMax }) {
  const { theme } = useOutletContext();
  const isDark = theme !== 'light';
  let hidevar=ExceptionVariables.hiddenroichart;
  const filtered = fulldataset?.plot9?.filter(varObj => varObj?.effectiveness?.toFixed(3) > 0 && !hidevar?.includes(varObj?.variable));
  const isStacked = filtered?.some(item => item.frequency);
  const pairMax = isStacked ? 2.5 * maxValuedynamicVolume : maxValuedynamicVolume;
  
  // Check if frequency exists in the dataset to determine stacking
 

  // Transform data for stacked chart if frequency exists
  let categories = [];
  let series = [];

  if (isStacked) {
    let groupedData = {};

    filtered?.forEach(item => {
      if (!groupedData[item.variable]) {
        groupedData[item.variable] = {};
      }
      groupedData[item.variable][item.frequency] = 
        Number(item.effectiveness?.toFixed(3)) || 0;
    });

    // categories = [...new Set(fulldataset?.plot9?.map(item => item.frequency))];
    categories = [...new Set(filtered?.map(item => item.frequency))];
    const variableTypes = Object.keys(groupedData);
    
    series = variableTypes.map(variable => ({
      name: variable,
      data: categories.map(freq => groupedData[variable][freq] || 0),
    }));
  } else {
    // Non-stacked chart
    // categories = fulldataset?.plot9?.map(item => item.variable);
    categories = filtered?.map(item => item.variable);
    series = [{
      name: "Effectiveness",
      // data: fulldataset?.plot9?.map(it => Number(it?.effectiveness?.toFixed(3)) || 0),
      data: filtered?.map(it => Number(it?.effectiveness?.toFixed(3)) || 0),
    }];
  }

  ({ categories, series } = alignSingleBarLeft(categories, series));
  const barColumnWidth = `${Math.min(70, Math.max(categories?.length || 1, 1) * 11)}%`;

  const options = {
    chart: {
      id: `Download-Effectiveness for Media Variables`,
      type: "bar",
      stacked: isStacked,
      toolbar: { show: true },
      background: 'transparent',
    },
    grid: { show: false },
    tooltip: {
      theme: isDark ? 'dark' : 'light',
    },
    title: {
      text: `Effectiveness for Media Variables (${type})`,
      align: 'center',
      style: CHART_TITLE_STYLE,
    },
    colors: CHART_PALETTE,
    plotOptions: {
      bar: { columnWidth: barColumnWidth, dataLabels: { position: "top" } },
    },
    dataLabels: {
      enabled: isStacked?false:true,
      offsetY: -15,
      style: { fontFamily: "'JetBrains Mono', 'Inter', monospace", fontSize: "12px", fontWeight: 600 },
      formatter: (val) => (val == null ? "" : Number(val).toFixed(3)),
    },
    xaxis: {
  categories:    categories   ?.map((item) => {
      const variable = item;
      if (!variable) return []; // Handle cases where `variable` is undefined or null
    
      const words = variable.split(/[\s_]+/);
      if (words.length <= 2) {
        // If there are 2 or fewer words, keep them as a single item array
        return [words.join(" ")];
      } else {
        // Split into two parts: first two words and the rest
        return [words.slice(0, 2).join(" "), words.slice(2).join(" ")];
      }
    })
  ,
      title: { text: '', style: { fontWeight: 600, fontSize: "12px" } },
      labels: {
        rotate: -50,
        rotateAlways: true,
        formatter: (val) => hideBarPadLabel(val),
        style: {
          fontWeight: 500,
          fontSize:"10px",
        },
        offsetY: -6,},
    },
    yaxis: {
      opposite: false,
      axisBorder: { show: true },
      labels: {
        style: { fontWeight: 500, fontSize: "11px" },
        formatter: formatAxisTick,
      },
      min: 0,
      max: Number.isFinite(Number(axisMax)) && Number(axisMax) > 0
        ? Number(axisMax)
        : Number.isFinite(pairMax) && pairMax > 0 ? Math.ceil(pairMax) : niceAxisMax,
      forceNiceScale: false,
    },
    annotations: {
      yaxis: [{
        y: 0,
        borderColor: '#6C757D',
        label: {
          text: '',
          style: { color: '#6C757D', background: '#1A252F' },
        },
      }],
    },
    legend: { show: isStacked, fontSize: "12px" },
  };

  return (
    <>
      <div className="rr-chart-period">
        <small>Time Period: {range}</small>
      </div>
      <div className="rr-chart-yaxis">
        <span className="rr-chart-yaxis-label">Effectiveness (per GRP / 1000 IMP / 1000 INR)</span>
        <div className="rr-chart-yaxis-body">
          <Chart className="rr-apex rr-apex-bar"
            align="center"
            options={options}
            series={series}
            type="bar"
            height={320}
            width={'100%'}
          />
        </div>
      </div>
    </>
  );
}

export default SingleBarChart3;
